import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("nl_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Normalize any error into a printable string (handles Pydantic 422 arrays)
export function extractApiError(err, fallback = "Errore") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d
      .map((e) => (e?.msg ? `${(e.loc || []).join(".")} ${e.msg}`.trim() : JSON.stringify(e)))
      .join(" · ");
  }
  if (typeof d === "object") {
    return d.msg || JSON.stringify(d);
  }
  return String(d);
}

// Attach normalized error message on the axios error itself
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err) err.friendlyMessage = extractApiError(err);
    return Promise.reject(err);
  }
);

export function setToken(token) {
  if (token) localStorage.setItem("nl_token", token);
  else localStorage.removeItem("nl_token");
}

export function getToken() {
  return localStorage.getItem("nl_token");
}

